// extracted by mini-css-extract-plugin
export default {"btn":"NextStoryButton_btn__gr3YR","icon":"NextStoryButton_icon__DAnY6"};